var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.computedClass,style:(_vm.computedStyle)},_vm._l((_vm.links),function(ref){
var link = ref.link;
var svg = ref.svg;
return _c('a',_vm._g({key:link,staticClass:"social-icons__link",attrs:{"href":link,"target":"_blank"},domProps:{"innerHTML":_vm._s(svg)}},{
			dragstart: _vm.preventLinks ? function (e) { return e.preventDefault(); } : function () { return null; },
			click: _vm.preventLinks ? function (e) { return e.preventDefault(); } : function () { return null; },
		}))}),0)}
var staticRenderFns = []

export { render, staticRenderFns }